import { gql } from '@apollo/client';

export const SignUpQuery = gql`
  mutation SignUp($input: AccountsSignUpInput) {
    accounts {
      signUp(input: $input) {
        error
      }
    }
  }
`;
